(() => {
  if (customElements.get('cm-product-copy')) return;

  const spellings = {
    color: 'colour', colors: 'colours', colored: 'coloured', coloring: 'colouring', colorful: 'colourful',
    watercolor: 'watercolour', watercolors: 'watercolours', multicolor: 'multicolour', multicolored: 'multicoloured',
    favorite: 'favourite', favorites: 'favourites', jewelry: 'jewellery', cozy: 'cosy', cozier: 'cosier',
    personalize: 'personalise', personalized: 'personalised', personalizing: 'personalising', personalization: 'personalisation',
    customize: 'customise', customized: 'customised', customizing: 'customising', customization: 'customisation',
    organize: 'organise', organized: 'organised', organizing: 'organising', organization: 'organisation', organizer: 'organiser', organizers: 'organisers',
    customizable: 'customisable', travelers: 'travellers', traveler: 'traveller', gray: 'grey',
    fiber: 'fibre', fibers: 'fibres', center: 'centre', centers: 'centres', aluminum: 'aluminium', mold: 'mould', molds: 'moulds', molded: 'moulded', molding: 'moulding'
  };
  const spellingPattern = new RegExp(`\\b(${Object.keys(spellings).join('|')})\\b`, 'gi');
  const matchCase = (word, replacement) => {
    if (word === word.toUpperCase()) return replacement.toUpperCase();
    if (word[0] === word[0].toUpperCase()) return replacement[0].toUpperCase() + replacement.slice(1);
    return replacement;
  };

  class CraftMintProductCopy extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || !document.documentElement.lang.toLowerCase().startsWith('en')) return;
        this.polish();
      });
    }

    polish() {
      for (const element of this.querySelectorAll('p,li')) {
        if (element.querySelector('a,img,video,table,input,button,svg')) continue;
        const text = element.textContent.replace(/[🌍🌎🌏]/gu, '').trim();
        if (/^Imported(?:\s+(?:Product|Item))?\s*[.!]?$/i.test(text)) element.remove();
      }
      const walker = document.createTreeWalker(this, NodeFilter.SHOW_TEXT, {
        acceptNode: (node) => node.parentElement?.closest('script,style,pre,code,textarea') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT
      });
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      for (const node of nodes) {
        const original = node.nodeValue;
        if (/https?:\/\/|\b\S+@\S+\.\S+\b/.test(original)) continue;
        node.nodeValue = original
          .replace(spellingPattern, (word) => matchCase(word, spellings[word.toLowerCase()]))
          .replace(/\b(?:Note:\s*)?This(?:\s+kit)?\s+is\s+an\s+imported\s+(?:product|item)\.\s*/gi, '')
          .replace(/\bImported\s+(?:Product|Item)\s+Notice\s*:\s*/gi, 'Product information: ')
          .replace(/\bImported\s*(?:Product|Item)?\s*:\s*/gi, 'Product information: ')
          .replace(/\b(an)\s+imported\s+/gi, (phrase, article) => `${matchCase(article, 'a')} `)
          .replace(/\bimported\b\s*/gi, '')
          .replace(/\s*—\s*/g, ' - ');
      }
    }
  }

  customElements.define('cm-product-copy', CraftMintProductCopy);
})();
